// import { TEST_DISPATCH } from "../actions/types";
import { GET_CART, GET_CART_PRODUCTS, CART_LOADING } from "../actions/types";
const initialState = {
    cart: [],
    cartproducts: [],
    loading: false,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_CART:
            return {
                ...state,
                cart: action.payload.cart,
            };

        case GET_CART_PRODUCTS:
            return {
                ...state,
                cartproducts: action.payload,
            };

        case CART_LOADING:
            return {
                ...state,
                loading: !state.loading,
            };
        default:
            return state;
    }
}
